import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const SecondaryButton = styled(Button)<ButtonProps>(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  borderRadius: 4,
  padding: 6,
  fontWeight: 'bold',
  textTransform: 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export default function StyledButton(props: any) {
  return <SecondaryButton {...props}>{props.children}</SecondaryButton>;
}
